import { declaracaoPendente } from 'volto-ministerio-publico-federal/helpers/Noticias/declaracao';
import { excedeLimitesNoticia } from 'volto-ministerio-publico-federal/helpers/Noticias/limites';

export const MOTIVO_LIMITES =
  'Reduza o título ou a descrição ao limite de caracteres para salvar.';
export const MOTIVO_DECLARACAO =
  'Marque a declaração de ciência sobre dados pessoais e/ou sensíveis (Privacidade) para salvar.';

/**
 * Motivo pelo qual o formulário de notícia não pode ser salvo, ou `null` se
 * pode. Usado por `Add` e `Edit` para desabilitar o botão e explicar no
 * `title`.
 */
export const motivoBloqueioSalvar = (
  type: string | undefined,
  formData: Record<string, unknown> | undefined,
): string | null => {
  if (excedeLimitesNoticia(type, formData)) return MOTIVO_LIMITES;
  if (declaracaoPendente(type, formData)) return MOTIVO_DECLARACAO;
  return null;
};
